import { render, staticRenderFns } from "./VideoSettings.vue?vue&type=template&id=1aba6f38&scoped=true"
import script from "./VideoSettings.vue?vue&type=script&lang=js"
export * from "./VideoSettings.vue?vue&type=script&lang=js"
import style0 from "./VideoSettings.vue?vue&type=style&index=0&id=1aba6f38&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba6f38",
  null
  
)

export default component.exports